import { useEffect, useLayoutEffect, useState } from 'react';

type Themes = 'light' | 'dark';

/**  */
const useTheme = (initialTheme: Themes = 'light') => {
	const [theme, setTheme] = useState<Themes>(initialTheme);

	useEffect(() => {
		const _stTheme = localStorage.getItem('theme');
		if (!!_stTheme && _stTheme !== initialTheme) {
			const _th = _stTheme as Themes;
			if (_th) {
				setTheme(_th);
			}
		}
	}, []);

	useEffect(() => {
		localStorage.setItem('theme', theme);
		document.documentElement.setAttribute('data-theme', theme);
	}, [theme]);

	const toggleTheme = () => {
		return setTheme((pr) => {
			if (pr === 'light') {
				return 'dark';
			} else {
				return 'light';
			}
		});
	};

	return [theme, setTheme, toggleTheme] as const;
};

export default useTheme;
